import { NostrEvent } from '@nostr/tools/core'
import { Content } from '@tiptap/react'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { sha256 } from '@noble/hashes/sha2.js'
import { SelectableItem } from '../RelaySelector'
import { PrimitiveAtom } from 'jotai'

type TCachedPost = {
  nsfw: boolean
  quietReply: boolean
  protected: boolean
  relaySelection: SelectableItem[]
  content: Content
}

const cachedPosts = new Map()

export function getCachedPostAtom(
  defaultContent: string,
  parentEvents: undefined | NostrEvent[],
  init: () => TCachedPost
): PrimitiveAtom<TCachedPost> {
  let key = parentEvents?.map((pe) => pe.id).join(',') || 'new'
  if (defaultContent) key += '/' + sha256(new TextEncoder().encode(defaultContent))

  const cached = cachedPosts.get(key)
  if (cached) return cached

  const storage = createJSONStorage<TCachedPost>(() => window.sessionStorage)
  const initial = init()
  const atom = atomWithStorage<TCachedPost>(`pec:${key}`, initial, storage)

  cachedPosts.set(key, atom)

  return atom
}
